import { z } from "zod";

const envSchema = z.object({
	// Required — app throws if missing or invalid
	REACT_APP_API: z.url(),
	REACT_APP_ENV: z.enum(["development", "staging", "production"]),

	// Optional — feature flags, disabled if absent
	REACT_APP_CALENDLY_URL: z.url().optional(),
	REACT_APP_FEATUREBASE_APP_ID: z.string().optional(),
	REACT_APP_GOOGLE_MAP_API_KEY: z.string().optional(),
	REACT_APP_USE_LABELING_V2: z.string().optional(),
	REACT_APP_ENABLE_PAGING_TIMINGS: z.string().optional(),
});

const env = envSchema.parse(window.__ENV__);

const config = Object.freeze({
	api: Object.freeze({
		baseUrl: `${env.REACT_APP_API}/api/v1`,
		socketUrl: env.REACT_APP_API,
	}),
	env: env.REACT_APP_ENV,
	features: Object.freeze({
		calendly: Object.freeze({
			enabled: !!env.REACT_APP_CALENDLY_URL,
			url: env.REACT_APP_CALENDLY_URL,
		}),
		featurebase: Object.freeze({
			enabled: !!env.REACT_APP_FEATUREBASE_APP_ID,
			appId: env.REACT_APP_FEATUREBASE_APP_ID,
		}),
		googleMaps: Object.freeze({
			enabled: !!env.REACT_APP_GOOGLE_MAP_API_KEY,
			apiKey: env.REACT_APP_GOOGLE_MAP_API_KEY,
		}),
		labelingV2: !!env.REACT_APP_USE_LABELING_V2,
		pagingTimings: !!env.REACT_APP_ENABLE_PAGING_TIMINGS,
	}),
});

export default config;
